import React from 'react';

import TagV2, { TagV2Size } from '../TagV2';
import { LetterpressTagWrapper } from './LetterpressTag.styles';

export interface LetterpressTagProps {
  className?: string;
  size?: TagV2Size;
}

const LetterpressTag = (props: LetterpressTagProps): JSX.Element => {
  const { className, size = TagV2Size.LARGE } = props;
  return (
    <LetterpressTagWrapper>
      <TagV2 size={size} className={className}>
        Letterpress
      </TagV2>
    </LetterpressTagWrapper>
  );
};

export default LetterpressTag;
